<template>
  <button
    :class="[
      bem.b(),
      bem.m(type),
      bem.m(size),
      bem.is('round', round),
      bem.is('loading', loading),
      bem.is('disabled', disabled)
    ]"
    :type="nativeType"
    :disabled="disabled || loading"
    @click="emitClick"
    @mousedown="emitMousedown"
  >
    <template v-if="iconPlacement === 'left'">
      <cms-icon v-if="loading || slots.icon">
        <loading v-if="loading"></loading>
        <template v-else-if="slots.icon">
          <component :is="slots.icon"></component>
        </template>
      </cms-icon>
    </template>
    <slot></slot>
    <template v-if="iconPlacement === 'right'">
      <cms-icon v-if="loading || slots.icon">
        <loading v-if="loading"></loading>
        <template v-else-if="slots.icon">
          <component :is="slots.icon"></component>
        </template>
      </cms-icon>
    </template>
  </button>
</template>

<script lang="ts">
// 先定义组件选项
export default {
  name: 'cms-button',
  // 不接收父组件额外传的属性
  inheritAttrs: false
}
</script>

<script setup lang="ts">
import Loading from '@chenms-zj/components/internal-icon/Loading'
import { createNamespace } from '@chenms-zj/utils/create'
import { buttonEmits, buttonProps } from './button'
import { useSlots } from 'vue'

const bem = createNamespace('button')

const props = defineProps(buttonProps)
const emit = defineEmits(buttonEmits)
const slots: any = useSlots()

const emitClick = (e: MouseEvent) => {
  emit('click', e)
}

const emitMousedown = (e: MouseEvent) => {
  emit('mousedown', e)
}
</script>

<style scoped></style>
